import { z } from "zod";
import {
  CorrectionsReviewDeclineReason,
  CorrectionsReviewDeclineReasonSchema,
} from "@remi/enums/corrections-review/decline-reason";
import { TaskType } from "@remi/enums/task-type";

export const MAX_CORRECTIONS_REVIEW_NOTE_LENGTH = 2000;

export const isCorrectionsReviewNoteRequired = (reason: CorrectionsReviewDeclineReason) =>
  reason === CorrectionsReviewDeclineReason.OTHER || reason === CorrectionsReviewDeclineReason.NOT_ENOUGH_INFORMATION;

const ReviewCorrectionsFlagFlaggedSchema = z.object({
  flagKey: z.string().min(1),
  score: z.number(),
  openProblem: z.number(),
  needsFixNow: z.number(),
  problemKind: z.string().nullable(),
  namedProjectIds: z.array(z.number().int()),
  namedProjectCategories: z.array(z.string()),
  payInsteadOfReturn: z.number().nullable(),
  questionSet: z.string(),
  model: z.string(),
  cutoffAt: z.iso.datetime(),
  conversationItemId: z.string().min(1),
});

const ReviewCorrectionsFlagDecidedSchema = z.object({
  decisionKey: z.string().min(1),
  outcome: z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("CORRECTIONS"), correctionsProjectId: z.number().int() }),
    z.object({ kind: z.literal("APPEASEMENT"), appeasementId: z.string().min(1) }),
    z
      .object({
        kind: z.literal("NOTHING_NEEDED"),
        reason: CorrectionsReviewDeclineReasonSchema,
        note: z.string().max(MAX_CORRECTIONS_REVIEW_NOTE_LENGTH),
      })
      .refine((outcome) => !isCorrectionsReviewNoteRequired(outcome.reason) || outcome.note.trim().length > 0, {
        message: "A note is required for this reason",
        path: ["note"],
      }),
    z.object({
      kind: z.literal("AUTOMATION_CORRECTIONS_OPEN"),
      correctionsProjectIds: z.array(z.number().int()).min(1),
    }),
  ]),
});

export const ReviewCorrectionsFlagTaskAttemptSchema = z
  .object({
    type: z.literal(TaskType.REVIEW_CORRECTIONS_FLAG),
    flagged: ReviewCorrectionsFlagFlaggedSchema.optional(),
    decided: ReviewCorrectionsFlagDecidedSchema.optional(),
  })
  .refine((data) => (data.flagged === undefined) !== (data.decided === undefined), {
    message: "Exactly one of flagged or decided must be set",
  });
